import { render, staticRenderFns } from "./OfficeBuildingIcon.vue?vue&type=template&id=0b55cad6&"
import script from "./OfficeBuildingIcon.vue?vue&type=script&lang=js&"
export * from "./OfficeBuildingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports